<div class="apply-job-container">
  <mat-dialog-title>
    <h2>Apply for this position</h2>
    <p class="font-20 margin-top-10 margin-bottom-10">
      Please fill the details below and we will get in touch with you
    </p>
  </mat-dialog-title>
  <mat-dialog-content>
    <form
      name="form"
      (ngSubmit)="f.form.valid && processData()"
      #f="ngForm"
      novalidate
    >
      <div class="row">
        <div class="col-md-6">
          <div class="form-group padding-right-10 margin-bottom-mobile-0">
            <!-- APPLY JOB: NAME -->
            <mat-form-field>
              <input
                matInput
                type="text"
                placeholder="Name"
                [(ngModel)]="applyJobData.name"
                name="jobname"
                #jobname="ngModel"
                minlength="1"
                maxlength="32"
                (keypress)="keyPressAlpha($event)"
                required
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group margin-bottom-mobile-0">
            <!-- APPLY JOB:  POSITION APPLIED FOR -->
            <mat-form-field>
              <input
                matInput
                type="text"
                placeholder="Position Applied for"
                [(ngModel)]="applyJobData.positionApplied"
                name="positionapplied"
                #positionapplied="ngModel"
                (keypress)="keyPressAlpha($event)"
                required
              />
              
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group padding-right-10 margin-bottom-mobile-0">
            <!-- APPLY JOB : MOBLIE NUMBER -->
            <mat-form-field>
              <input
                matInput
                type="text"
                placeholder="Mobile"
                [(ngModel)]="applyJobData.mobileNumber"
                name="mobile"
                #mobile="ngModel"
                minlength="10"
                maxlength="10"
                [pattern]="mobNumberPattern"
                required
              />
              <mat-error *ngIf="mobile.errors?.pattern">Mobile number not valid.</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group margin-bottom-mobile-0">
            <!-- APPLY JOB:  EMAIL ID -->
            <mat-form-field>
              <input
                matInput
                type="text"
                placeholder="Email"
                [(ngModel)]="applyJobData.emailId"
                name="email"
                #email="ngModel"
                [pattern]="emailPattern"
                required
                minlength="1"
                maxlength="64"
              />
              <mat-error *ngIf="email.errors?.pattern"
                >Please Enter valid Email.</mat-error
              >
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- APPLY JOB: MESSAGE -->
      <div class="row">
        <div class="col-md-12">
          <div class="form-group margin-bottom-mobile-0">
            <mat-form-field>
              <textarea
                matInput
                placeholder="Message (Max. 100 Characters)"
                maxlength="100"
                [(ngModel)]="applyJobData.message"
                name="message"
                #message="ngModel"
                required
              ></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- APPLY JOB: UPLOAD RESUME -->
      <div class="row">
        <div class="col-md-12">
          <div class="form-group margin-bottom-mobile-0">
              <app-file-input
                (fileChange)="onFileChange($event)"
                placeholder="Upload Resume"
                [(ngModel)]="fileName"
                name="fileInput"
                required
              >
                <button type="button" mat-raised-button color="primary">
                  Choose
                </button>
              </app-file-input>
          </div>
        </div>
      </div>
      <!-- CAREER:JOB SUBMIT -->
      <div class="margin-top-20">
        <button
          mat-raised-button
          color="primary"
          class="mat-button-large"
          type="submit"
          [disabled]="!f.valid"
        >
          Submit
        </button>
        <button
          mat-button
          color="primary"
          class="mat-button-large margin-left-25"
          mat-dialog-close
        >
          Cancel
        </button>
      </div>
    </form>
  </mat-dialog-content>
</div>
